module.exports = __webpack_public_path__ + "static/media/fig_17.520d7a21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_17.jpg
// module id = 647
// module chunks = 0